'use client ';

import { ShoppingBagIcon } from 'lucide-react';
import useCartStore from '@/src/lib/state-stores/cartStore';
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from '../ui/sheet';

import ListOfCarts from '@/src/app/[locale]/carts/components/ListOfCarts';
import { TSession } from '.';
import SlideUpAnimation from '../animation/SlideUpAnimation';
import { useTranslations } from 'next-intl';
import { useSession } from 'next-auth/react';

import useToggleCartMenu from '@/src/lib/state-stores/toggleCartMenu';
import ScrollVisibilityComponent from '../animation/ScrollVisibilityComponent';

const UserCart = ({ session: serverSession }: TSession) => {
  const { data: clientSession } = useSession();
  const session = serverSession ?? clientSession;
  const { carts, setCartId } = useCartStore();

  const t = useTranslations('header');

  const { isSheetCartOpen, handleOpenChange, handleCloseCartSheet } = useToggleCartMenu();

  return (
    <Sheet open={isSheetCartOpen} onOpenChange={handleOpenChange}>
      <SheetTrigger asChild aria-label="show the card" role="button">
        <button
          onClick={() => {
            setCartId('');
            handleOpenChange(true);
          }}
        >
          <div className="relative">
            <ShoppingBagIcon className="text-primary cursor-pointer" />
            {session?.user && carts.length ? (
              <div className="centerButton absolute top-[-50%] left-[50%] grid aspect-square min-w-6 place-items-center rounded-full bg-red-500 text-xs text-white">
                <SlideUpAnimation uniqueKey={carts.length}>{carts.length}</SlideUpAnimation>
                {/* <RollingStaggerNumber number={totalItems} /> */}
              </div>
            ) : null}
          </div>
          <div className="hidden lg:block">
            <ScrollVisibilityComponent session={session} />
          </div>
        </button>
      </SheetTrigger>

      <SheetContent className="styled-scroll overflow-y-auto p-5 pt-12">
        <SheetTitle className="mb- absolute top-4 left-4">{t('carts')}</SheetTitle>
        <SheetDescription></SheetDescription>
        <ListOfCarts onCloseCartSheet={handleCloseCartSheet} isSlide={true} />
      </SheetContent>
    </Sheet>
  );
};

export default UserCart;
